import { useContext } from 'react'
import { TableContext } from './Table'

const useTable = () => {
  const { data, columns, options, ...other } = useContext(TableContext)

  return { data, columns, options, ...other }
}

export default useTable